import { c as _c } from "react/compiler-runtime";
import useStore from '@/components/playbook-builder/hooks/use-store';
import type { Banner } from '../../error-warning-list/error-warning-list';
type RulesErrorContext = {
  contextType: 'rules_error_context';
  conditionId: string;
  problemMarkers: {
    message: string;
  }[];
};
const getRulesWarningContext = (banner: Banner) => {
  const context = banner.description.context as RulesErrorContext | undefined;
  return banner.type === 'warning' && context?.contextType === 'rules_error_context' ? context : undefined;
};

/** The rules form shows these under their condition, so the panel's banner list leaves them out. */
export const isRulesWarning = (banner: Banner) => !!getRulesWarningContext(banner);

/** Returns a map of conditionId -> warning message for the node's rules conditions. */
export const useRulesWarningMessages = nodeId => {
  const $ = _c(3);
  const {
    data: t0
  } = useStore();
  const {
    banners
  } = t0;
  let map;
  if ($[0] !== banners || $[1] !== nodeId) {
    map = new Map();
    for (const banner of banners) {
      const context = getRulesWarningContext(banner);
      if (banner.nodeId !== nodeId || !context) {
        continue;
      }
      map.set(context.conditionId, context.problemMarkers?.[0]?.message || banner.description.message);
    }
    $[0] = banners;
    $[1] = nodeId;
    $[2] = map;
  } else {
    map = $[2];
  }
  return map;
};